import { activeSiteConfig } from "@config/site/site-config";
import type { RawProductAttribute } from "@graphql/generated/types";

export const isMarketWithLoyalty = activeSiteConfig?.isMarketWithLoyalty ?? false;
export const isNewsletterRequiredForEccoClub =
    isMarketWithLoyalty && process.env.NEXT_PUBLIC_NEWSLETTER_REQUIRED_FOR_ECCO_CLUB === "true";
export const hasPointsAndTiers = activeSiteConfig?.eccoClubConfig?.hasPointsAndTiers ?? true;
export const hasLoyaltyPointsHistory = isMarketWithLoyalty && hasPointsAndTiers;

/**
 * Checks if the product has ECCO Club access for the current site's country.
 * Logic is case-insensitive and handles comma-separated country codes.
 */
export const checkHasEccoClub = (productAttributes: RawProductAttribute[]): boolean => {
    const attributeValue = productAttributes.find((attr) => attr.name === "HasEccoClub")?.value;

    if (!attributeValue) return false;

    const currentCountry = activeSiteConfig.country.toLowerCase();

    return attributeValue
        .split(",")
        .map((v: string) => v.trim().toLowerCase())
        .includes(currentCountry);
};
